import type { ProjectInfoSGSchemaType, ProjectTierPriceSGSchemaType } from '@/global/schemas/subgraph.schema';
import type { ProjectTier } from '@/global/types/project.type';

const calculateCurrentTierIndex = (totalCap: number, sold: number, borders: number[]) => {
  if (totalCap === sold) return borders.length - 1;
  return borders.findIndex(item => item > sold);
};

const calculateCurrentTier = (
  borders: number[],
  prices: number[],
  sold: number,
  currentTierIndex: number,
): ProjectTier => {
  const isSingleTier = borders.length === 1;
  const currentBorder = borders[currentTierIndex] ?? 0;
  const previousBorder = borders[currentTierIndex - 1] ?? 0;
  const currentPrice = prices[currentTierIndex] ?? 0;

  return {
    price: currentPrice,
    cap: isSingleTier ? (borders[0] ?? 0) : currentBorder - previousBorder,
    sold: isSingleTier || sold < (borders[0] ?? 0) ? sold : sold - previousBorder,
  };
};

const formatProjectData = (projectData: ProjectInfoSGSchemaType, tierData: ProjectTierPriceSGSchemaType) => {
  return {
    ...projectData,
    sold: Number(projectData.sold),
    border: tierData.border.map(Number),
    price: tierData.price.map(Number),
  };
};

export { calculateCurrentTierIndex, calculateCurrentTier, formatProjectData };
